import { useEffect } from "react";
import Page from "../Meetings/page"

const Meetings = () => {

  useEffect(() => {    
    document.title = 'Брокер-туры | Личный кабинет Брокера THE FIVE';
    
  }, []);


  return (
    <Page eventTypeId={2} />
  )
}

export default Meetings